import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store';

Vue.config.productionTip = false;
export const $eventBus = new Vue();

new Vue({
  router,
  store,
  provide: {$eventBus},
  render: (h) => h(App)
}).$mount("#app");
